import { useSelector } from "react-redux";
import ReactDOM from "react-dom";
import Navbar from "react-bootstrap/Navbar";
import { logOut, loginCount } from "../redux/reducers/authReducer";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import { FaBars, FaBell } from "react-icons/fa";
import { TbLogout } from "react-icons/tb";
import { AnimatePresence, motion } from "framer-motion";
import { FaUserAlt, FaGamepad } from "react-icons/fa";
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useState, useEffect, useRef } from "react";
import Spinner from "react-bootstrap/Spinner";
import DiscountRules from "./DiscountRules";
import saleIcon from '../assets/STN.jpg';
import damageIcon from '../assets/Damage Product.jpg';
import profitIcon from '../assets/Profit.jpg';
import budgetIcon from '../assets/budget.png'



const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  //console.log('++++++++++++++++++++++++++++++++ This is Dashboard Page ++++++++++++++++++++++++')
  const accessToken = useSelector((state) => state.auth.accessToken);
  const user_id = useSelector((state) => state.auth.user_id);
  console.log("user_id",user_id)
  const UserDetails = useSelector((state) => state.auth.UserDetails);
  console.log('UserDetails',UserDetails?.emp_id)
  const isAdmin = UserDetails?.access_control?.includes("cashdiscountadmin");


  const [isVisible, setIsVisible] = useState(false);
  const popupDivRef = useRef(null);
  const [loadingButton, setLoadingButton] = useState(false);

  const [profileObj, setProfile] = useState({
    "name": 'myProfile',
    "iframelink": 'https://iipl.retool.com/embedded/public/baf8cae6-4248-4168-9f21-9f7adb71e5e1'
  })

  const [showDiscountRules, setShowDiscountRules] = useState(false); // State to control the visibility of DiscountRules


  // console.log("user=========", user_id);
  // console.log("userData", UserDetails);
  console.log("UserDetails",UserDetails)
  const userLogout = () => {
    // event.preventDefault();
    setLoadingButton(true);
    setTimeout(() => {
      setLoadingButton(false);
      dispatch(logOut());
      navigate("/");
    }, 1000);
  };

  let storeArray = [
    {
      id: 1,
      icon: "https://happimobiles.s3.ap-south-1.amazonaws.com/imageurl/manager-discount.png",
      name: "Manager Discount",
    },
    {
      id: 2,
      icon: "https://happimobiles.s3.ap-south-1.amazonaws.com/imageurl/lost-sale.png",
      name: "Missed Customer",
    },
    {
      id: 3,
      icon: "https://happimobiles.s3.ap-south-1.amazonaws.com/imageurl/uniform.png",
      name: "Uniform",
    },
    {
      id: 4,
      icon: "https://happimobiles.s3.ap-south-1.amazonaws.com/imageurl/footfall.png",
      name: "Foot Fall",
    },
    {
      id: 5,
      icon: "https://happimobiles.s3.ap-south-1.amazonaws.com/imageurl/offer.png",
      name: "Cash Discount",
      iframelink:
        "https://iiplwork.retool.com/embedded/public/38f3a08f-e55c-43f0-833b-61c9b8fe3fab",
    },
   
  ];

  let adminArray = [
    {
      id: 1,
      icon: "https://happimobiles.s3.ap-south-1.amazonaws.com/imageurl/manager-discount.png",
      name: "Manager Discount",
    },
    {
      id: 2,
      icon: "https://happimobiles.s3.ap-south-1.amazonaws.com/imageurl/lost-sale.png",
      name: "Missed Customer",
    },
    {
      id: 3,
      icon: "https://happimobiles.s3.ap-south-1.amazonaws.com/imageurl/setting.png",
      name: "Settings",
      iframelink:
        "https://iiplwork.retool.com/embedded/public/7273b208-7936-4368-974c-0e89e6ae28b1",
    },
    {
      id: 4,
      icon: "https://happimobiles.s3.ap-south-1.amazonaws.com/imageurl/4-Callrecording.png",
      name: "Call Record",
    },
    {
      id: 5,
      icon: "https://happimobiles.s3.ap-south-1.amazonaws.com/imageurl/uniform.png",
      name: "Uniform",
    },
    {
      id: 6,
      icon: "https://happimobiles.s3.ap-south-1.amazonaws.com/imageurl/footfall.png",
      name: "Foot Fall",
    },
    {
      id: 7,
      icon: "https://happimobiles.s3.ap-south-1.amazonaws.com/imageurl/marketing-coupon.png",
      name: "Marketing Promotor",
    },
    {
      id: 8,
      icon: "https://happimobiles.s3.ap-south-1.amazonaws.com/imageurl/report.png",
      name: "Report",
      iframelink: "https://iiplwork.retool.com/embedded/public/f9133cfa-719f-4d9b-9f58-7f30eeb2593d"
    },
    {
      id: 9,
      icon: "https://happimobiles.s3.ap-south-1.amazonaws.com/imageurl/offer.png",
      name: "Cash Discount",
      iframelink:
        "https://iiplwork.retool.com/embedded/public/38f3a08f-e55c-43f0-833b-61c9b8fe3fab",
    },
    {
      id: 10,
      icon: "https://happimobiles.s3.ap-south-1.amazonaws.com/imageurl/eb_reading.png",
      name: "EB recording",
    },
    // {
    //   id: 11,
    //   icon: "https://assets.happimobiles.net/assets/media/login-icons/report.png",
    //   name: "Employee Management App Logs",
    //   iframelink: "https://iipl.retool.com/embedded/public/60b0c128-0593-4b89-8e91-4db13f67982a"
    // },
    {
      id: 12,
      icon: damageIcon,
      name: "Sale Return",
      iframelink:
        "https://iipl.retool.com/embedded/public/8a506e81-ab0e-4ee3-823f-1c40b6b87c57",
      applyRadius:true
    },
    {
      id: 13,
      icon: saleIcon,
      name: "Stock Transfer",
      iframelink:
        "https://iipl.retool.com/embedded/public/c5814aec-248d-4ce2-8210-aaefdd5e08a0",
       applyRadius:true
    },
    {
      id: 14,
      icon: "https://happimobiles.s3.ap-south-1.amazonaws.com/imageurl/eb_reading.png",
      name: "Discount Rules",
      iframelink:
        `https://discount-rules.happimobiles.com/`,

    },
    {
      id: 14,
      icon: "https://www.shutterstock.com/shutterstock/photos/1236595024/display_1500/stock-vector-two-way-arrow-icon-logo-template-1236595024.jpg",
      name: "STN Timeline",
      iframelink:
        `https://dev-discountrules.iipl.app/timelinereport`,
        applyRadius:true

    },
    {
      id: 15,
      icon: "https://cdn-icons-png.flaticon.com/512/10105/10105669.png",
      name: "Queue Jobs",
      iframelink:
        `https://dev-discountrules.iipl.app/queuejobs`,
        applyRadius:true

    },
    {
      id: 16,
      icon: "https://cdn-icons-png.flaticon.com/512/8053/8053573.png",
      name: "STN Config",
      iframelink:
        `https://tm-api.happimobiles.com/api/approval-config/config-form`,
        applyRadius:true

    },
    
  ];

  let profitabilityArray= [
    {
      id: 1,
      icon: profitIcon,
      name: "Profitability ",
      iframelink:
        "https://iiplwork.retool.com/embedded/public/28a7cee0-8aa9-458b-8c28-06e53a8495c6",
       applyRadius:true
    },
    {
      id: 2,
      icon: budgetIcon,
      name: "Finance Report ",
      iframelink:
        "https://dev-discountrules.iipl.app/financereports",
       applyRadius:true
    },
     {
      id:3,
      icon: "https://cdn-icons-png.flaticon.com/512/508/508166.png",
      name: "Scheme Receivables",
      iframelink:
        "https://dev-discountrules.iipl.app/scheme_receivables",
       applyRadius:true
    },
      {
      id:4,
      icon: "https://cdn-icons-png.flaticon.com/512/2224/2224878.png",
      name: "Contacts",
      iframelink:
        "https://contact.happimobiles.com/?view=admin",
       applyRadius:true,
       emp_id:"HM0014"
    },

      {
      id:4,
      icon: "/sync.gif",
      name: "One-Assist",
      iframelink:
        "https://mis-api.happimobiles.com/oneassist/",
       applyRadius:true,
       emp_id:"HM0014"
    },
          {
      id:4,
      icon: "https://previews.123rf.com/images/arctina/arctina1808/arctina180800029/112365256-increase-profit-graph-growing-arrow-flat-vector-icon-illustration-simple-black-symbol-on-white.jpg",
      name: "Profit Report",
      iframelink:
        "https://dev-discountrules.iipl.app/profit_report",
       applyRadius:true,
    }
    
  ];

  // //Login Count API
  // useEffect(() => {
  //   let payload = {
  //     emp_id: UserDetails.emp_id,
  //     module: "happi-discount",
  //   };
  //   dispatch(loginCount(payload));
  // }, []);

  const navigateHandler = (item) => {
    if (item.name === "Discount Rules") {
      setIsVisible(false); // Close the popup if open

      navigate(`/discount-rules/${user_id}`, { state: { customProp: item }, replace: true }); // Navigate to the DiscountRules route
      console.log("Opening Discount Rules component...");
      // You can perform actions here like opening a modal or rendering a different component.
    } else {
      // Handle navigation to other components or routes as before
      navigate("/discount", { state: { customProp: item }, replace: true });
    }
  };
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        isVisible &&
        popupDivRef.current &&
        !popupDivRef.current.contains(event.target)
      ) {
        setIsVisible(false);
      }
    };

    
    // Attach the event listener when the component mounts
    document.addEventListener("click", handleOutsideClick);

    // Remove the event listener when the component unmounts
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [isVisible]);

  const getAdminData=()=>{
    if(UserDetails.emp_id=="HM0040") return [ {
      id: 1,
      icon: "https://happimobiles.s3.ap-south-1.amazonaws.com/imageurl/eb_reading.png",
      name: "Discount Rules",
      iframelink:
        `https://discount-rules.happimobiles.com/`,

    },
    {
      id: 2,
      icon: "https://happimobiles.s3.ap-south-1.amazonaws.com/imageurl/offer.png",
      name: "Cash Discount",
      iframelink:
        "https://iiplwork.retool.com/embedded/public/38f3a08f-e55c-43f0-833b-61c9b8fe3fab",
    },
  ]
    else return adminArray
  }

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };
  return (
    <>
      <section className="dashboard">
        <div className="container-fluid p-0">
          <div className="row">
            <div className="col-md-3">
              <div className="happi-logo">
                <a href="#">
                  <img
                    src="https://happimobiles.s3.ap-south-1.amazonaws.com/imageurl/logo.png"
                    class="img-fluid"
                  />
                </a>
              </div>
            </div>
            <div className="col-md-7">
              <h1>Dashboard</h1>
            </div>
            <div className="col-md-2">
              <div className="d-flex justify-content-end align-items-center sign-out">
                <span className="d-flex align-self-center">Hi,</span>
                <span className="d-flex self-align-start justify-content-end">
                  {UserDetails?.name}
                </span>
                <div
                  className="d-flex align-items-center justify-content-center user-icon"
                  onClick={toggleVisibility}
                >
                  <FaUserAlt />
                </div>
              </div>
            </div>
          </div>
          {
            (UserDetails?.access_control?.includes("cashdiscountmanager")|| UserDetails?.access_control?.includes("cashdiscountstore"))&&
          <div className="row d-flex align-items-center justify-content-center mt-4 pt-5">
            <div className="col-11">
              <div class="dashboard-components">
                <div className="folded position-relative">
                  <h2>
                    <FaGamepad />
                    Store
                  </h2>
                </div>

                <div className="component-body">
                  <div className="row">
                    {storeArray?.map((item, index) => {
                      return (
                        <div className="col-md-2 col-sm-2 mb-5">
                          <div className="text-center component-content">
                            <div
                              className="component-body-icons"
                              onClick={() => navigateHandler(item)}
                            >
                              <img src={item.icon} />
                            </div>
                            <p>{item.name}</p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>}
          {
            isAdmin&&
          <div className="row d-flex align-items-center justify-content-center mt-4">
            <div className="col-11">
              <div class="dashboard-components">
                <div className="folded position-relative">
                  <h2>
                    <FaGamepad />
                    Admin
                  </h2>
                  <div className="component-body">
                    <div className="row">
                      {getAdminData()?.map((item, index) => {
                        return (
                          <div className="col-md-2 col-sm-2 mb-3">
                            <div className="text-center component-content">
                              <div
                                className={item?.applyRadius?"component-body-icons img-border":"component-body-icons"}
                                onClick={() => navigateHandler(item)}
                              >
                                <img src={item.icon} />
                              </div>
                              <p>{item.name}</p>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>}
{UserDetails?.profitability &&
  <div className="row d-flex align-items-center justify-content-center mt-4">
            <div className="col-11">
              <div class="dashboard-components">
                <div className="folded position-relative">
                  <h2>
                    <FaGamepad />
                    Profitability
                  </h2>
                  <div className="component-body">
                    <div className="row">
                      {profitabilityArray?.map((item, index) => UserDetails.emp_id==item?.emp_id?<div className="col-md-2 col-sm-2 mb-3">
                            <div className="text-center component-content">
                              <div
                                className={item?.applyRadius?"component-body-icons img-border":"component-body-icons"}
                                onClick={() => navigateHandler(item)}
                              >
                                <img src={item.icon} />
                              </div>
                              <p>{item.name}</p>
                            </div>
                          </div>: <div className="col-md-2 col-sm-2 mb-3">
                            <div className="text-center component-content">
                              <div
                                className={item?.applyRadius?"component-body-icons img-border":"component-body-icons"}
                                onClick={() => navigateHandler(item)}
                              >
                                <img src={item.icon} />
                              </div>
                              <p>{item.name}</p>
                            </div>
                          </div> 
                     
                      )}
                    </div>
                  </div>
                  </div>
                  </div>
                  </div>
                  </div>
}
          {!UserDetails?.access_control.length>0&&<>
            <div className="row d-flex align-items-center justify-content-center mt-4">
            <div className="col-11">
              <div class="dashboard-components d-flex justify-content-center align-items-center">
                <h3 style={{ color: 'white' }}>You don't have access Please contact Admin ..!</h3>
                  </div>
                  </div>
                </div>       
          </>
          }
        </div>
      </section>


      {showDiscountRules && <DiscountRules />} {/* Render DiscountRules component when showDiscountRules is true */}


      {isVisible && (
        <div className="popup-div" ref={popupDivRef}>
          <div className="user-card-details">
            <div className="icon-name">
              <div className="avatar-name">
                <span>{UserDetails?.name[0]}</span>
              </div>
              <div className="name-user">{UserDetails?.name}</div>
            </div>
          </div>
          <div className="profile">
            <div className="icon-profile" onClick={() => navigateHandler(profileObj)}>
              <FaUserAlt className="icon-prof" />
              <div>
                <h6>
                  My Profile<span>Account settings and more</span>
                </h6>

              </div>
            </div>
            <div className="btn-logout">
              <button
                type="button"
                onClick={(e) => {
                  userLogout();
                  e.stopPropagation();
                }}
              >
                {loadingButton ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <span> sign out </span>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Dashboard;
